<template lang="pug">
	textarea(:value="value", @input="input")
</template>

<script>
export default {
  name: "MatrixTextbox",
	props: ["value"],
	methods: {
    input(e) {
      this.$emit("input", e.target.value);
    }
	}
};
</script>

<style lang="scss" scoped>
textarea {
	font-size: 14px;
  border: none;
  outline: none;
  appearance: none;
  padding: 20px;
  background: $white;
	min-height: 100px;
	flex: 1 1 100%;
	border: 1px solid #c4c4c4;
	border-radius: 2px;
}
</style>